/* Age gate: shows the dialog until the visitor confirms, then remembers it in a cookie. */
(function () {
  var COOKIE = 'he_age_ok';
  var d = document.getElementById('AgeGate');
  if (!d || typeof d.showModal !== 'function') return;
  function hasCookie() {
    return document.cookie.split('; ').some(function (c) { return c.indexOf(COOKIE + '=1') === 0; });
  }
  if (hasCookie() && d.dataset.force !== 'true') return;

  var main = document.getElementById('MainContent');
  var accepted = false;
  // Esc / close requests must not dismiss the gate. closedby="none" covers newer browsers;
  // the cancel handler covers older ones, and the close handler catches anything that slips through
  // (e.g. Chrome closing on a second Esc without firing a cancelable cancel event).
  d.addEventListener('cancel', function (e) { e.preventDefault(); });
  d.addEventListener('close', function () {
    if (accepted) return;
    if (!d.open) d.showModal();
  });
  d.querySelector('[data-age-confirm]').addEventListener('click', function () {
    var days = parseInt(d.dataset.days, 10) || 30;
    document.cookie = COOKIE + '=1; max-age=' + days * 86400 + '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    accepted = true;
    d.close();
    if (main) main.inert = false;
    window.HE && window.HE.overlayChanged(-1);
  });
  d.showModal();
  if (main) main.inert = true;
  window.HE && window.HE.overlayChanged(1);
})();
